module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils_lib_geometry_geojson__;